import React, { Component } from 'react';
//import { observer } from 'mobx-react';
//import { withRouter } from 'react-router';
import $ from 'jquery';
import moveToTopImg from '../../images/common/moveToTop.png';
import './MoveToTop.css';
import WithRouter from '../Extensions/WithRouter';

class MoveToTop extends Component {
  componentDidMount() {
    const $window = $(window);
    const $moveToTop = $('.move_to_top');
    $(document).scroll('scroll.moveToTop', () => {
      if ($window.scrollTop() > 300) {
        $moveToTop.show();
      } else {
        $moveToTop.hide();
      }
      $moveToTop.css('opacity', ($window.scrollTop() - 200) / 600);
    });
    $moveToTop.on('click', () => {
      $('html, body')
        .stop()
        .animate({ scrollTop: '0' }, 300);
    });
  }

  render() {
    return (
      <div className="move_to_top">
        <a>
          <img src={moveToTopImg} alt="" />
        </a>
      </div>
    );
  }
}

export default WithRouter(MoveToTop);
